import { useEffect, useState } from "react";
import { PaginationRequest, PaginationResult } from "../../../api/Common/Util";
import { useLoad } from "../../../components/Common/useLoading";
import InventoryMovementService from "../../../api/Inventory/InventoryMovementService";
import { getUsersById } from "../../../api/identity";
import { useAuthorization, useProtocolAuthFilter } from "../../../components/Authorization/useAuthorization";
import { getProtocolsById } from "../../../api/protocol";

const propsTemplate = () => {
    return {
        ...new PaginationRequest()
        , includedTypes: null
        , status: null
        , assignmentTypes: null
        , assignId: null
        , useId: null
    }
}
export default function useMoves(props = propsTemplate()) {
    const [request, setRequest] = useState(props)
    const [pagedMoves, setPagedMoves] = useState(new PaginationResult())
    const [isLoading, withLoad] = useLoad()

    const [isAuthenticated, user, isAuthorized] = useAuthorization()
    const [canViewProtocol, isAuthLoading] = useProtocolAuthFilter()

    useEffect(() => {
        if (request == null) return
        withLoad(() => findMoves(request))
    }, [isAuthenticated])


    const Navigation = {
        ToPage: async ({ page }) => {
            const newRequest = pagedMoves.ToPage(page);
            if (newRequest == null) return
            setRequest({ ...request, ...newRequest })
            await withLoad(() => findMoves({ ...request, ...newRequest }))
        },

        Search: async (props = propsTemplate()) => {
            setRequest({ ...request, ...props })
            await withLoad(() => findMoves({ ...request, ...props }))
        },
        Reload: async () => {
            await withLoad(() => findMoves(request))
        }
    }

    async function findMoves(props) {
        let assignmentGeneralConcat = appendAssignment("", isAuthorized, "GeneralInventory.View", "general")
        let assignmentProtocolConcat = appendAssignment(assignmentGeneralConcat, isAuthorized, "ProtocolInventory.View", "protocol")
        let assignmentProtocolLaboratoryKitConcat = appendAssignment(assignmentProtocolConcat, isAuthorized, "LaboratoryKitInventory.View", "protocollaboratorykit")

        const assignmentTypes =
            request.assignmentTypes == null
                ? assignmentProtocolLaboratoryKitConcat
                : request.assignmentTypes

        const result = await InventoryMovementService.GetMoves({ ...props, assignmentTypes: assignmentTypes })

        result.SortColumn = request.sortColumn
        result.SortOrder = request.sortOrder

        const userIds = result.Values.reduce((set, move) => {
            set.add(move.userId)
            return set
        }, new Set());

        const usersResponse = (await getUsersById(Array.from(userIds))).data;
        const usersMap = new Map(usersResponse.map(user => [user.userId, user]));
        result.Values.forEach(move => {
            move.user = usersMap.get(move.userId)
        })
        result.Values = result
            .Values
            .filter(m => validateAssignType(m.assignment, "general") || canViewProtocolMove(m, canViewProtocol) || validateAssignType(m.assignment, "protocollaboratorykit"))

        const protocolIds = result.Values.reduce((set, move) => {
            if (move.assignment.assignId != null && (validateAssignType(move.assignment, "protocol") || validateAssignType(move.assignment, "protocollaboratorykit"))) 
                set.add(move.assignment.assignId)
            return set
        }, new Set());
        const protocolsMap = (await getProtocolsById(Array.from(protocolIds)))
            .data
            .reduce((map, protocol) => {
                if (map.has(protocol.id)) return map
                map.set(protocol.id, protocol)
                return map
            }, new Map())
        result.Values.forEach(move => {
            move.assignName =
                (validateAssignType(move.assignment, "protocol") || validateAssignType(move.assignment, "protocollaboratorykit")) && protocolsMap.has(move.assignment.assignId * 1)
                    ? protocolsMap.get(move.assignment.assignId * 1).title
                    : null
        })

        setPagedMoves(result)
    }

    function canViewProtocolMove(move, canViewProtocolCallback) {
        return (validateAssignType(move.assignment, "protocol") || validateAssignType(move.assignment, "protocollaboratorykit")) && canViewProtocolCallback(move.assignment.assignId)
    }


    //Concatena el tipo de movimiento si tiene los permisos para verlo, mientras mas permisos mas tipos de movimientos podra ver
    function appendAssignment(root, isAuthorizedCallback, permission, assigment) {
        if (isAuthorizedCallback([permission])) {
            return root + (root == ""
                ? assigment
                : `,${assigment}`)
        }
        return root
    }

    function validateAssignType(assignment, value) {
        if (assignment == null || assignment == undefined) return false

        if (assignment.assignmentType?.toLowerCase() == value) return true
    }

    return [pagedMoves, isLoading, Navigation]
}